exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".points-w[data-v-3ecac2b7]{position:absolute;top:50%;left:50%;z-index:999;width:60%;min-width:800px;background-size:100% 100%;border-radius:10px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-image:var(--dialogBgImg)}.input_width[data-v-3ecac2b7]{width:200px}.bottom_button[data-v-3ecac2b7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[data-v-3ecac2b7] .el-radio__label{display:none}", ""]);

// exports
